/* ============================================================================
   EMSOIR — MOTION  ·  Hafif, mobil-öncelikli, GPU dostu.
   - Scroll-reveal (IntersectionObserver, tek seferlik)
   - Header scroll durumu (cam efekti)
   - Zarif ürün/kart tilt (SADECE masaüstü, dokunmada kapalı)
   - Reduced-motion tam saygı, bağımlılık yok, tek dosya.
   ============================================================================ */
(function () {
  "use strict";
  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var CAN_HOVER = window.matchMedia && window.matchMedia("(hover: hover)").matches;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---- Scroll-reveal: bölümleri girişte yumuşakça getir ---- */
  function initReveal() {
    if (REDUCED || !("IntersectionObserver" in window)) return;
    var skip = /header|announcement|popup|drawer|cart/i;
    var sections = Array.prototype.slice.call(document.querySelectorAll(".shopify-section"));
    // İlk bölümü (hero/above-fold) gizleme — anında görünsün.
    var toReveal = sections.filter(function (s, i) {
      return i > 0 && !skip.test(s.id || "");
    });
    if (!toReveal.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("em-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.06, rootMargin: "0px 0px -8% 0px" });
    toReveal.forEach(function (s) { s.classList.add("em-reveal"); io.observe(s); });
  }

  /* ---- Header: aşağı kaydırınca cam efekti ---- */
  function initHeader() {
    var header = document.querySelector(".header-wrapper .header, .header");
    if (!header) return;
    var last = -1;
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var on = y > 30;
      if (on !== last) { header.classList.toggle("header--emsoir-scrolled", on); last = on; }
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Zarif tilt: ürün/kart görselleri fareyle çok hafif eğilir (masaüstü) ---- */
  function initTilt() {
    if (REDUCED || !CAN_HOVER) return;
    var targets = document.querySelectorAll("[data-em-tilt]");
    targets.forEach(function (el) {
      var max = parseFloat(el.getAttribute("data-em-tilt")) || 6;
      el.style.transformStyle = "preserve-3d";
      el.style.transition = "transform .25s var(--em-ease, ease)";
      el.addEventListener("mousemove", function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        el.style.transform = "perspective(900px) rotateX(" + (-py * max) + "deg) rotateY(" + (px * max) + "deg)";
      });
      el.addEventListener("mouseleave", function () {
        el.style.transform = "perspective(900px) rotateX(0) rotateY(0)";
      });
    });
  }

  /* ---- Parallax: [data-em-parallax] öğeleri scroll ile çok hafif kayar ---- */
  function initParallax() {
    if (REDUCED) return;
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-em-parallax]"));
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute("data-em-parallax")) || 0.12;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  ready(function () {
    initReveal();
    initHeader();
    initTilt();
    initParallax();
    // Shopify tema editöründe bölüm yüklenince yeniden tara
    document.addEventListener("shopify:section:load", function () {
      initReveal(); initTilt(); initParallax();
    });
  });
})();
